import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import S from './FiltreParProjet.module.scss';
import * as s from '../../ressources/StyleGlobal/StyleGlobal';
import FormulaireSelectionProjetsArborecense from '../UI/FormulaireSelectionProjetsArborecense/FormulaireSelectionProjetsArborecense';
import * as actions from '../../services/actions';
import { jsDictionaryEquals } from '../../ressources/functionJS/jsDictionaryEquals';

const FiltreParProjet = () => {
  // Redux hooks
  const dispatch = useDispatch();
  const filtreProjectsListId = useSelector(
    (state) => state.authentifie.filtre_projects_list_id
  );

  // State management
  const [projectsListId, setProjectsListId] = useState(filtreProjectsListId);

  // Effect to handle projects list updates
  useEffect(() => {
    if (!jsDictionaryEquals(projectsListId, filtreProjectsListId)) {
      dispatch(actions.gererFiltreParProjet(projectsListId));
    }
  }, [projectsListId, filtreProjectsListId, dispatch]);

  // Handler for projects list changes
  const handleProjectsList = (newProjectsList) => {
    setProjectsListId(newProjectsList);
  };

  return (
    <div className={S.Profil}>
      <div className={s.row}>
        <div className={s.col_sm_12}>
          <FormulaireSelectionProjetsArborecense
            gererProjetsList={handleProjectsList}
            preconfigurerProjectsListId={projectsListId}
          />
        </div>
      </div>
    </div>
  );
};

export default FiltreParProjet;
